import { all, call, put, takeLatest } from "redux-saga/effects";
import { KHACHHANG_THEMMOI } from "actions/DanhSachKhachHang/ThemMoiKhachHang/actionTypes";
import {
  themMoiKhachHangSuccess,
  themMoiKhachHangFailure,
} from "actions/DanhSachKhachHang/ThemMoiKhachHang";
import themMoiKhachHangApi from "service/themMoiKhachHangApi";
import { pushNotification } from "utils/notifications";

function* themMoiKhachHang(action) {
  try {
    console.log(action)
    const response = yield call(themMoiKhachHangApi.themMoiKhachHang, action.dataPost);
    console.log(response)
    if (response.ok) {
      if(response.data.Error==0)
        pushNotification(response.data.Message, "success", "TOP_CENTER", 1000);
      else
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
     
      yield put(themMoiKhachHangSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(themMoiKhachHangFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(themMoiKhachHangFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(KHACHHANG_THEMMOI, themMoiKhachHang);
}

export default function* themMoiKhachHangSagas() {
  yield all([watchGetRequest()]);
}
